module.exports = __webpack_public_path__ + "static/media/3.90fd2ed8.JPG";